module.exports = __webpack_public_path__ + "static/media/prefeitura.7c3f513e.png";